import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getActivityLogsAsync } from './activityLogThunk';
const initialState = {
    status: APIStatus.IDLE,
    logs: []
};
export const activityLogSlice = createSlice({
    name: 'activityLog',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getActivityLogsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getActivityLogsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.logs = action.payload;
        })
            .addCase(getActivityLogsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default activityLogSlice.reducer;
